
// Inline SVG scroll ticks — 32px spacing
export default function ScrollTicks() {
  const count = 340;
  const h = count * 32;
  return (
    <span className="scroll-ticks" aria-hidden>
      <svg
        width={8}
        height={h}
        viewBox={`0 0 8 ${h}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {Array.from({ length: count }, (_, i) => (
          <line
            key={i}
            x1={1.5}
            y1={i * 32}
            x2={5.5}
            y2={i * 32}
            stroke="rgba(0,0,0,0.3)"
            strokeWidth="0.5"
          />
        ))}
      </svg>
    </span>
  );
}